import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    fetchAppData,
} from "./system/app-slice";
import {useTranslate} from "./system/useTranslate";
import {Toast} from "primereact/toast";
import Auth from "./auth";
import {check} from "./auth/auth-slice";
import {Route, Routes, useLocation, useNavigate} from "react-router-dom";
import PageNotFound from "./system/page-not-found";
import Sidebar from "./system/components/sidebar";
import Toolbar from "./system/components/toolbar";
import Page from "./system/components/page";
import {setHeaderToken} from "./system/api";
import {Sidebar as PrimeSidebar} from "primereact/sidebar";
import PageDisabled from "./system/page-disabled";
import './App.css';
import {pagesMap} from './pages'
import {PrimeReactProvider} from "primereact/api";
import UnderConstruction from "./system/under-construction";
import LoadingLottie from "./system/components/loading-lottie";
import AcceptDenyNotificationDialog from "./pages/components/accept-deny-notification-dialog";

import useWorkspaceMembership from "./models/workspace-membership/use-workspace-membership";
import useUserEventLog from "./models/user-event-log/use-user-event-log";


function App(props) {
    const dispatch = useDispatch();
    const {config, prompt, pages, status, homePageIndex, isDesktop, message, isDeveloper, workspaceMembershipData, notifications} = useSelector((state) => state.app);
    const {user, authLoading, isAuthenticated, userChecked} = useSelector(state => state.auth);
    const [visibleSidebar, setVisibleSidebar] = useState(isDesktop);
    const [selectWorkspaceDialog, setSelectWorkspaceDialog] = useState(false);
    const [aiAssistantVisible, setAiAssistantVisible] = useState(false);
    const workspaceMembership = useWorkspaceMembership();
    const userEventLog = useUserEventLog();
    const translate = useTranslate();
    const toast = useRef();
    const selectWorkspaceRef = useRef();
    const location = useLocation();
    const navigate = useNavigate();
    const host = window.location.hostname; // help.zofino.ir
    const sub = host.split(".")[0];        // help

    const [extraPages, setExtraPages] = useState([])

    useEffect(() => {
        dispatch(fetchAppData());
    }, [dispatch]);

    useEffect(()=>{
        if(config){
            const themeLink = document.getElementById("theme-css");
            if (themeLink) {
                themeLink.href = config["dark-mode"]
                    ? process.env.PUBLIC_URL + "/assets/themes/dark-theme.css"
                    : process.env.PUBLIC_URL + "/assets/themes/light-theme.css";
            }

            if (config.language==="fa"){
                document.body.classList.add("lang-fa");
            }
            else {
                document.body.classList.remove("lang-fa");
            }

            document.title = `${translate(config['app-name'])}`;
            dispatch(check());


        }
    },[config, dispatch])

    useEffect(()=>{
        if (user){
            setHeaderToken(`Bearer ${user?.jwt}`);
        }
    },[user])

    useEffect(()=>{
        if (message){
            toast.current.show({life:8000, severity: message.severity, content: <span className="w-full">{message.content}</span>, contentClassName:"flex align-items-center"});
        }
    },[message])

    const getPageConfigs=()=>{
        const _currentPageIndex = pages.findIndex(e=>`/${location.pathname.split("/")[1]}` === e["nav-url"]);
        return pages[_currentPageIndex]??pages[homePageIndex];
    }

    const view = (status) =>{
        if (config&&config["under-construction"]&&!isDeveloper){
            return <UnderConstruction/>
        }
        else {
            switch (status) {
                case 'loading':return (
                    <LoadingLottie/>
                );
                case 'succeeded':
                    return (
                        <div className={`${config.dir} ${config.language==="fa"&&"lang-fa"} flex flex-column h-full w-full `}>
                            <Toast className="pr-3" ref={toast} position="bottom-left"/>

                            {config.authorization?(isAuthenticated?(
                                <div  className="w-full h-full flex flex-1 align-items-center justify-content-center">
                                    <div className="w-full h-full flex flex-1 align-items-center">
                                        {(config.sidebar) && (
                                            <div className={`h-full ${!getPageConfigs()?.sidebar && "p-hidden"}`}>
                                                {isDesktop ? (<Sidebar extraPages={extraPages} expanded={visibleSidebar}/>):(
                                                    <div className="flex lg:hidden shadow-2">
                                                        <PrimeSidebar className="w-fit" dir={config.dir} showCloseIcon={false} position={`${config.dir==="rtl"?"right":"left"}`} visible={visibleSidebar} onHide={()=>{setVisibleSidebar(false)}}>
                                                            <Sidebar expanded={true} onChange={(e)=>{setVisibleSidebar(false)}}/>
                                                        </PrimeSidebar>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        <div className="h-full flex-1 flex flex-column overflow-hidden">
                                            {getPageConfigs()?.toolbar && (
                                                <Toolbar
                                                    setVisibleSidebar={setVisibleSidebar}
                                                    visibleSidebar={visibleSidebar}
                                                    pageConfig={getPageConfigs()}
                                                />
                                            )}

                                            <div className="flex-1 w-full overflow-auto relative">
                                                <Routes>
                                                    <Route path="/" element={pages[homePageIndex].page?(pages[homePageIndex].disabled?<PageDisabled/>:React.createElement(pagesMap[pages[homePageIndex].page],{...pages[homePageIndex]})):(pages[homePageIndex].disabled?<PageDisabled/>:<Page {...pages[homePageIndex]}/>)}/>
                                                    {
                                                        pages.map(e=>(
                                                            e.page?(<Route key={`${e.name}-${e['nav-url']}`} path={e['nav-url']} element={e.disabled?<PageDisabled/>:React.createElement(pagesMap[e.page]?pagesMap[e.page]:PageNotFound,{...e})}/>):(<Route key={`${e.name}-${e['nav-url']}`} path={e['nav-url']} element={e.disabled?<PageDisabled/>:<Page {...e}/>}/>)
                                                        ))
                                                    }
                                                    <Route path="*" element={<PageNotFound/>}/>
                                                </Routes>
                                                {/*<Button onClick={()=>{setAiAssistantVisible(true)}} className="w-fit px-1 border-noround-left shadow-none border-none absolute left-0" style={{bottom:"1rem"}} icon={<Icon icon="mi mi:help" className="text-lg"/>}/>*/}
                                            </div>



                                        </div>
                                    </div>
                                </div>
                            ):<Auth/>):(
                                <>
                                    {config.sidebar && (<Sidebar/>)}
                                    <Routes>
                                        {/*{pages.length>0&&}<Route path="/" element={<Page {...pages[0]}/>}/>*/}
                                        {
                                            pages.map(e=><Route key={`${e.name}-${e['nav-url']}`} path={e['nav-url']} element={<Page {...e}/>}/>)
                                        }
                                        <Route path="*" element={<PageNotFound/>}/>
                                    </Routes>
                                </>
                            )}
                        </div>
                    );
                case 'failed':return (
                    <div>{translate("error")}</div>
                )
                default: return(<div>{status}</div>)
            }
        }


    }

    return (

        <PrimeReactProvider>
            <div className="w-screen h-screen overflow-hidden surface-ground flex align-items-center justify-content-center">
                {userChecked?view(status):view('loading')}
                {config&&<AcceptDenyNotificationDialog visible={userEventLog.acceptDenyDialogVisible} setVisible={userEventLog.setAcceptDenyDialogVisible}/>}

            </div>
        </PrimeReactProvider>

    );
}

export default App;
